var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "integration" }, [
    !_vm.selectedIntegration
      ? _c("div", { staticClass: "no integration-card" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("SelectIntegration")))])
        ])
      : _vm._e(),
    _vm._v(" "),
    !!_vm.selectedIntegration
      ? _c(
          "div",
          { staticClass: "integration-info-container" },
          [
            _c("object-main-info", {
              attrs: {
                fields: _vm.fields,
                identifier: _vm.cardObjectIdentifier,
                "identifier-label": _vm.$tc("Label", 1),
                height: _vm.cardHeight
              }
            }),
            _vm._v(" "),
            !_vm.showPermissions
              ? _c("integration-specific-info", {
                  attrs: {
                    custom: _vm.selectedIntegration.custom_attributes
                      ? _vm.getIntegrationCustomParams
                      : [],
                    auth: _vm.selectedIntegration.auth_params_json
                      ? _vm.getIntegrationAuthParams
                      : []
                  }
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce9dd2d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce9dd2d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/Integrations/Integration.vue
// module id = null
// module chunks = 